<template>
  <section>
    <div class="content_bg">
      <div class="content">

        <p style="color:white; font-weight: 500; font-size: 32px;margin-top: 32px;margin-bottom: 30px;">
          먼데이리스의 효율적인 개발 방식이<br/>궁금하시다면?
        </p>

        <router-link to="tech">
          <img width="330" class="pc ani_twisting" src="@/assets/images/tech_btn.png" />
          <img width="260" class="mobile ani_twisting" src="@/assets/images/tech_btn.png" />
        </router-link>
        
        <p style="color:white; font-weight: 300; font-size: 24px; margin-top: 50px;margin-bottom: 10px;">
          먼데이리스의 기술 스택
        </p>

        <div class="pc">
          <div style="display:flex; align-items:top; text-align: center; padding-left:250px; padding-right:250px;justify-content: space-between;">
            <img class="icon" src="@/assets/images/icon_github.png" />
            <img class="icon" src="@/assets/images/icon_objc.png" />
            <img class="icon" src="@/assets/images/icon_java.png" />
            <img width="74" style="padding-top: 40px;" src="@/assets/images/icon_devil.png" />
          </div>
          <div style="margin-top: 50px; display:flex; text-align: center; padding-left:250px; padding-right:250px;justify-content: space-between;">
            <img class="icon" src="@/assets/images/icon_aws.png" />
            <img class="icon" src="@/assets/images/icon_nodejs.png" />
            <img class="icon" src="@/assets/images/icon_mongodb.png" />
            <img class="icon" src="@/assets/images/icon_vue.png" />
          </div>
        </div>

        <div class="mobile">
          <div style="display:flex; align-items:top; text-align: center; justify-content: center;">
            <img class="icon" src="@/assets/images/icon_github.png" />
            <img class="icon" src="@/assets/images/icon_objc.png" />
          </div>
          <div style="display:flex; align-items:top; text-align: center; justify-content: center;">
            <img class="icon" src="@/assets/images/icon_java.png" />
            <img class="icon" src="@/assets/images/icon_devil.png" />
          </div>
          <div style="display:flex; align-items:top; text-align: center; justify-content: center;">
            <img class="icon" src="@/assets/images/icon_aws.png" />
            <img class="icon" src="@/assets/images/icon_nodejs.png" />
          </div>
          <div style="display:flex; align-items:top; text-align: center; justify-content: center;">
            <img class="icon" src="@/assets/images/icon_mongodb.png" />
            <img class="icon" src="@/assets/images/icon_vue.png" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
import Caption from "./Caption.vue";
import CaptionGreen from "./CaptionGreen.vue";
import CaptionWhite from "./CaptionWhite.vue"
import client from "../client/client";

export default {
  components: {
    Caption,
    CaptionGreen,
    CaptionWhite,
  },
  mounted() {},
  data() {
    return {};
  },
};
</script>
  
<style scoped>

.icon {
  display: block;
  width:88px;
  object-fit:contain;
}


.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: fit-content;
  position: relative;
  overflow: hidden;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #354566;
}

.content {
  width: 1140px;
  max-width: 1140px;
  text-align: center;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    padding-left: 40px;
    padding-right: 40px;
    justify-content: center;
    width: 100vw;
    height: fit-content;
    position: relative;
    overflow: hidden;
    background-color: #354566;
  }

  .content {
    width: 100%;
    text-align: center;
  }

  .icon {
    display: block;
    width:140px;
    object-fit:contain;
    padding: 20px;
  }
}
</style>
  